<template>
  <SkeletonItem
    :width="120"
    :height="120"
    :border-radius="'50%'"
  ></SkeletonItem>

  <div class="container">
    <div class="container__block-1">
      <SkeletonItem
        :width="120"
        :height="24"
      ></SkeletonItem>
    </div>

    <div class="container__block-2">
      <div class="container__block-2-inner">
        <SkeletonItem
          :width="162"
          :height="16"
        ></SkeletonItem>
      </div>
      <div class="container__block-2-inner">
        <SkeletonItem
          :width="132"
          :height="16"
        ></SkeletonItem>
      </div>
      <div class="container__block-2-inner">
        <SkeletonItem
          :width="196"
          :height="16"
        ></SkeletonItem>
      </div>
    </div>

    <SkeletonItem
      :width="longBlockWidth"
      :height="16"
    ></SkeletonItem>

    <SkeletonItem
      :width="longBlockWidth"
      :height="16"
    ></SkeletonItem>

    <SkeletonItem
      :width="shortBlockWidth"
      :height="16"
    ></SkeletonItem>
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  const { isMobile, isTablet } = useScreenSize();

  const longBlockWidth = computed(() => {
    if (isMobile.value) {
      return 320;
    }

    if (isTablet.value) {
      return 336;
    }

    return 700;
  });

  const shortBlockWidth = computed(() => {
    if (isMobile.value) {
      return 276;
    }

    if (isTablet.value) {
      return 236;
    }

    return 600;
  });
</script>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-8);
    box-sizing: border-box;
    padding: 0 50px 0 22px;

    &__block-1 {
      display: flex;
      box-sizing: border-box;
      padding: var(--alias-space-2) 0;

      @include adaptivity.mobile {
        justify-content: center;
      }
    }

    &__block-2 {
      display: block;
      margin-right: calc(-1 * var(--alias-space-8));
      margin-left: calc(-1 * var(--alias-space-8));

      &-inner {
        display: inline-flex;
        box-sizing: border-box;
        padding: var(--alias-space-4) var(--alias-space-8);
      }

      @include adaptivity.tablet {
        max-width: 336px;
      }

      @include adaptivity.mobile {
        text-align: center;
      }
    }

    @include adaptivity.mobile {
      padding: var(--alias-space-8) 0 var(--alias-space-16) 0;
    }
  }
</style>
